export default __webpack_public_path__ + "images/b7833c3e7ac490afca779bddef25f418.png";